import { render, staticRenderFns } from "./cart_item.vue?vue&type=template&id=8ae31da4&"
import script from "./cart_item.vue?vue&type=script&lang=js&"
export * from "./cart_item.vue?vue&type=script&lang=js&"
import style0 from "./cart_item.vue?vue&type=style&index=0&id=8ae31da4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports